import { Container } from "shared/components";

import { BlockView } from "./BlockView";
import styles from "./Content049.module.scss";
import { ListView } from "./ListView";

export const Content049 = ({ payload }) => {
  const template = payload?.template ?? "blocks";

  return (
    <div className={styles.wrapper}>
      <Container>
        {template === "blocks" ? (
          <BlockView payload={payload} />
        ) : (
          <ListView payload={payload} />
        )}
      </Container>
    </div>
  );
};

export default Content049;
